import { jsx as _jsx } from "react/jsx-runtime";
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { useChatBots } from 'hooks/useChatBots';
import { ChatbotModal } from '../chatBotModal';
const connectionLabels = {
    successBranch: 'Successful',
    failureBranch: 'Not succeeded',
};
const translatePayload = ({ payload, }) => {
    return [
        {
            id: uuid(),
            label: connectionLabels.successBranch,
            connection: payload.successNextNodeId,
        },
        {
            id: uuid(),
            label: connectionLabels.failureBranch,
            connection: payload.failNextNodeId,
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const { payload } = node;
    const fieldToUpdate = connection.connectionLabel === connectionLabels.successBranch
        ? 'successNextNodeId'
        : 'failNextNodeId';
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { [fieldToUpdate]: connectionId }) });
};
export const ChatBotNodeAttributes = {
    iconName: 'chat-bot',
    label: 'Chatbot',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: AvailabilityNode,
    ActionModal: ChatbotModal,
};
export function AvailabilityNode({ node }) {
    var _a, _b;
    const { items } = useChatBots();
    const { payload: { chatbotId }, } = node;
    const name = (_b = (_a = items === null || items === void 0 ? void 0 : items.find((item) => item.id === chatbotId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'Loading...';
    return (_jsx(TextContent, { children: _jsx(Text, { weight: "semibold", text: name }) }));
}
